import Share from './share-icon.svg';

export default Share;
